<template>
  <div class="portal-page info-preparing">
    <div class="portal-page__inner">
      <div class="info-preparing__card portal-panel">
        <img
          class="info-preparing__art"
          :src="illust.infoPreparing"
          alt="클립보드 옆에 앉아 있는 민트색 캐릭터"
        />
        <p class="info-preparing__kicker">정보마당</p>
        <h1 class="info-preparing__title">준비중이에요</h1>
        <p class="info-preparing__desc">내용을 정리하고 있습니다. 조금만 기다려 주세요.</p>
        <router-link to="/" class="portal-btn portal-btn--primary">홈으로</router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { illust } from '@/constants/illust'
</script>

<style lang="scss" src="./InfoPreparingPage.scss"></style>
